import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";

import { textFilter } from "utils/table";
import { IconButton } from "@mui/material";

import {
  openTemplateModal,
  openConfirmModal,
} from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";
import { Delete } from "@mui/icons-material";
import formatDate from "utils/formatDate";

const useQuickTextTemplateTableColumns = () => {
  const dispatch = useDispatch();

  const handleEdit = (rowData) => {
    const selectedTemplate = Object.assign({}, rowData);
    dispatch(
      openTemplateModal({
        selectedTemplate,
        showModal: true,
        modalTitle: "Update Quick Text Information",
      })
    );
  };

  const handleDelete = (rowData) => {
    dispatch(
      openConfirmModal({
        templateToDelete: rowData,
      })
    );
  };

  const columns = [
    {
      header: "Title",
      accessorKey: "title",
      filterVariant: "text",
      filterFn: textFilter,
      size: 60,
      enableSorting: false,
      Cell: ({ row }) => row?.original.title || "-",
    },
    {
      header: "Description",
      accessorKey: "description",
      filterVariant: "text",
      filterFn: textFilter,
      enableSorting: false,
      Cell: ({ row }) => row?.original.description || "-",
    },
    {
      header: "Created At",
      accessorKey: "created_at",
      filterVariant: "date",
      filterFn: textFilter,
      size: 100,
      accessorFn: (rowData) => formatDate(new Date(rowData?.created_at)),
      Cell: ({ cell }) => cell.getValue(),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableColumnFilter: false,
      enableSorting: false,
      size: 80,
      Cell: ({ row }) => {
        const rowData = row?.original;

        return (
          <div style={{ display: "flex" }}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(rowData);
              }}
              sx={{
                "&:hover": {
                  color: "secondary.main",
                },
              }}
            >
              <Tooltip title="Edit Quick Text" placement="top">
                <EditIcon data-action="edit-quick-text-icon" />
              </Tooltip>
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(rowData);
              }}
              sx={{
                "&:hover": {
                  color: "secondary.main",
                },
              }}
            >
              <Tooltip title="Delete Quick Text" placement="top">
                <Delete data-action="delete-quick-text-icon" />
              </Tooltip>
            </IconButton>
          </div>
        );
      },
    },
  ];

  return columns;
};

export default useQuickTextTemplateTableColumns;
